export const HOSTMAP_INFO_LIST_REQ = 'HOSTMAP_INFO_LIST_REQ'
export const HOSTMAP_INFO_LIST_SET = 'HOSTMAP_INFO_LIST_SET'
export const HOSTMAP_INFO_LIST_SUCCESS = 'HOSTMAP_INFO_LIST_SUCCESS'
export const HOSTMAP_INFO_LIST_ERROR = 'HOSTMAP_INFO_LIST_ERROR'

export const HOSTMAP_INFO_UPDATE_LIST_REQ = 'HOSTMAP_INFO_UPDATE_LIST_REQ'
export const HOSTMAP_INFO_UPDATE_LIST_SUCCESS =
  'HOSTMAP_INFO_UPDATE_LIST_SUCCESS'
export const HOSTMAP_INFO_UPDATE_LIST_ERROR = 'HOSTMAP_INFO_UPDATE_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/hostmap_info/hostmap_info.type.js